<template>
  <form class="form" @submit.prevent>
    <VBlock v-for="field in fields"
      :key="field.key"
      :maxWidth="field.width"
    >
      <component :is="getInputComponent(field)"
        :value="field.value"
        :name="field.key"
        @input="onFieldUpdate({ key: field.key, value: $event })"
        @change="onFieldUpdate({ key: field.key, value: $event })"
      >
        <VFormLabel v-if="field.label"
          :required="field.isRequired"
          :invalid="shouldShowError(field)"
          v-html="field.label"
        />
      </component>
    </VBlock>
  </form>
</template>

<script>
import VFormComment from '@/components/VFormComment.vue';
import VFormInputText from '@/components/VFormInputText.vue';
import VFormInputTextarea from '@/components/VFormInputTextarea.vue';
import VFormInputCheckbox from '@/components/VFormInputCheckbox.vue';

export const FIELD_TYPE_TEXT = Symbol('FIELD_TYPE_TEXT');
export const FIELD_TYPE_TEXTAREA = Symbol('FIELD_TYPE_TEXTAREA');
export const FIELD_TYPE_EMAIL = Symbol('FIELD_TYPE_EMAIL');
export const FIELD_TYPE_COMMENT = Symbol('FIELD_TYPE_COMMENT');
export const FIELD_TYPE_CHECKBOX = Symbol('FIELD_TYPE_CHECKBOX');

export default {
  name: 'VForm',

  props: {
    fields: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      shouldShowErrors: false,
    };
  },

  methods: {
    getInputComponent({ type }) {
      switch (type) {
        case FIELD_TYPE_TEXT:
        case FIELD_TYPE_EMAIL:
          return VFormInputText;
        case FIELD_TYPE_TEXTAREA:
          return VFormInputTextarea;
        case FIELD_TYPE_COMMENT:
          return VFormComment;
        case FIELD_TYPE_CHECKBOX:
          return VFormInputCheckbox;
        default:
          throw new TypeError(`Unsupported field type ${type}`);
      }
    },

    isFieldValid({ /* key, */ value, type, isRequired }) {
      switch (type) {
        case FIELD_TYPE_TEXT:
        case FIELD_TYPE_TEXTAREA:
          return isRequired ? !!value : true;
        case FIELD_TYPE_CHECKBOX:
          return isRequired ? value : true;
        case FIELD_TYPE_COMMENT:
          return true;
        case FIELD_TYPE_EMAIL:
          return /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/
            .test(value) || (!isRequired && !value);
        default:
          throw new TypeError(`Unsupported field type ${type}`);
      }
    },

    onFieldUpdate({ key, value }) {
      this.$emit('update', { key, value });
    },

    shouldShowError(field) {
      const { shouldShowErrors } = this;

      if (!shouldShowErrors) {
        return false;
      }

      return !this.isFieldValid(field);
    },

    validate() {
      this.shouldShowErrors = true;

      return Object.values(this.fields)
        .every(field => this.isFieldValid(field));
    },
  },
};
</script>

<style lang="scss" scoped>
.form {
  display: flex;
  flex-wrap: wrap;

  margin: -$gridGutter;
  padding: calc($gridGutter / 2);

  ::v-deep .block {
    padding: inherit;

    &:not(:first-child) {
      margin-top: 0;
    }

    @media screen and (max-width: 768px) {
      flex: 1 1 100% !important;
      max-width: 100% !important;
    }
  }
}
</style>
